import { isNull } from 'lodash'

export function isNumeric (n: any): boolean {
  return !isNaN(parseFloat(n)) && isFinite(n)
}

export async function sleep (ms: number) {
  return new Promise((resolve) =>{
    setTimeout(resolve, ms)
  })
}

export function calculateConversion(chats: number, contacts: number): number {
  return contacts > 0 ? parseFloat(((contacts / chats) * 100).toFixed(2)) : 0
}

export function base64ToFile (base64String: string, fileName: string): File {
  const findMimeType =  /(?<=data:)(.*)(?=;)/g.exec(base64String)

  if (isNull(findMimeType)) {
    console.error('base64ToFile | base64String:', base64String)
    throw new Error('Unable to find file mime TYPE')
  }

  const mimeType = findMimeType[0]
  const base64Data = base64String.replace(/^data:.+;base64,/, '')
  const byteCharacters = atob(base64Data)
  const byteNumbers = new Array(byteCharacters.length)

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }

  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: mimeType })

  return new File([blob], fileName, {
    type: mimeType,
  })
}
